__turbopack_context__.v({
  "asterisk": "label-module__Ydz1hW__asterisk",
  "disabled": "label-module__Ydz1hW__disabled",
  "label": "label-module__Ydz1hW__label",
  "sizeLg": "label-module__Ydz1hW__sizeLg",
  "srOnly": "label-module__Ydz1hW__srOnly",
});
